export default __webpack_public_path__ + "static/media/B01.ea199d24.png";